import { useMemo } from "react";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import get from "lodash/get";

export const GET_EXPERIMENT = gql`
	query webGetExperiment($experimentName: String!) {
		session {
			experiment(name: $experimentName) {
				group
			}
		}
	}
`;

/**
 * Get the value of an experiment check.
 * @param {string} experimentName - the experiment you'd like to check.
 * @param {object} [options] - useQuery options.
 * @returns {[[boolean], Object]} [experiment group name, useQuery response]
 */
function useExperiment(experimentName, options = {}) {
	// Fetch the Gatekeeper Check value from gql.
	const res = useQuery(GET_EXPERIMENT, { variables: { experimentName }, ...options });
	const experimentGroup = get(res, "data.session.experiment.group");

	// Memoized so the array doesn't change unless the contents change.
	return useMemo(() => [experimentGroup, res], [experimentGroup, res]);
}

/**
 * @param {string} experimentName - The name of the experiment you'd like to check.
 * @param {array} groups - The list of experiment groups the user is in.
 * @returns {boolean} - If the user is the experiment group specified.
 */
export function useIsExperimentGroup(experimentName, groups = []) {
	const [experimentGroup] = useExperiment(experimentName);
	return groups.some((group) => group === experimentGroup);
}

export default useExperiment;



// WEBPACK FOOTER //
// ./src/shared/hooks/useExperiment.js